import { Headline2 } from '@/components/common/Headline2'

interface H2Props {
  children: React.ReactNode
  weight?: 200 | 400 | 500 | 600 | 700 | 800
  color?: 'black' | 'primary' | 'secondary' | 'white'
  className?: string
}

export const H3 = ({ children, weight = 800, color = 'black', className = '' }: H2Props) => {
  return (
    <Headline2 tag="h3" weight={weight} color={color} className={`text-[24px] xl:text-[40px] !leading-[1.1] mb-[32px] lg:mb-[40px] ${className}`}>
      {children}
    </Headline2>
  )
}
